import Immutable from 'immutable';

export const getPresentStatusesFromSummary = borrowingSummary =>
  borrowingSummary
    .get('status', Immutable.Map())
    .filter(materialTypeCounts => materialTypeCounts.get('DIGITAL', 0) > 0 || materialTypeCounts.get('PHYSICAL', 0) > 0)
    .keySeq()
    .toList();

export const getTotalMaterialTypeCounts = borrowingSummary =>
  borrowingSummary
    .get('status', Immutable.Map())
    .reduce(
      (totalCount, countForStatus) =>
        totalCount
          .set('PHYSICAL', totalCount.get('PHYSICAL', 0) + countForStatus.get('PHYSICAL', 0))
          .set('DIGITAL', totalCount.get('DIGITAL', 0) + countForStatus.get('DIGITAL', 0)),
      Immutable.Map().asMutable()
    )
    .asImmutable();

export const getMaterialTypeCountsForStatus = (borrowingSummary, status) => {
  if (status) {
    return borrowingSummary.getIn(
      ['status', status.toUpperCase()],
      Immutable.Map({
        PHYSICAL: 0,
        DIGITAL: 0
      })
    );
  }

  return getTotalMaterialTypeCounts(borrowingSummary);
};

export const getTotalFromMaterialTypeCounts = countsByMaterialType =>
  countsByMaterialType.get('DIGITAL', 0) + countsByMaterialType.get('PHYSICAL', 0);

export const getTotalCountFromSummary = borrowingSummary =>
  borrowingSummary
    .get('status', Immutable.Map())
    .reduce((acc, countsByMaterialType) => acc + getTotalFromMaterialTypeCounts(countsByMaterialType), 0);

export const getCountsByStatusFromSummary = borrowingSummary =>
  borrowingSummary
    .get('status', Immutable.Map())
    .map(countsByMaterialType => getTotalFromMaterialTypeCounts(countsByMaterialType));

export const itemMatchesStatusFilter = (item, status) =>
  !status || status.toUpperCase() === item.get('status').toUpperCase();
